import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../shared/config/app-config';
import { UserService } from './../../../shared';

@Component({
  selector: 'app-patient-documents',
  templateUrl: './patient-documents.component.html',
  styleUrls: ['./patient-documents.component.css']
})
export class PatientDocumentsComponent implements OnInit {
  ModelRef: BsModalRef
  @Input() patientSWFId: number = null
  constructor(private Modalservice: BsModalService, private userService: UserService, private toastr: ToastrService) { }
  showloader: boolean = false
  currentuserDetails: any
  ngOnInit() {
    this.userService.currentUser.subscribe(data => { this.currentuserDetails = data })
  }
  /* ----------------accordian icon change function------------- */
  mask: any;
  eyemask() {
    var sd = document.getElementById("arrow-change");

    if (this.mask) {
      this.mask = false;
      sd.setAttribute("class", "fa fa-caret-right");

    } else {
      this.mask = true;
      sd.setAttribute("class", "fa fa-caret-down");
      this.fetchAllPatientDocument()
    }
  };

  /* ----------------Document from drag and drop field------------- */
  onDrop(files: FileList) {

    if (files.length == 1) {
      if (files[0].size <= 15728640) {
        if (files[0].type.split('/')[1] == 'pdf') {
          this.multipartFileUpload(files[0])
        }
        else
          document.getElementById("docError").innerHTML = this.userService.translateText('patient_portal.upload_page.unsupported_file_format.error')
      }
      else {
        document.getElementById("docError").innerHTML = this.userService.translateText('patient_portal.upload_page.15MB_file_allowed.error')
      }
    }
    else
      document.getElementById("docError").innerHTML = this.userService.translateText('patient_portal.upload_page.drag_only_file.error')
  }

  /* ----------------Document from input field------------- */
  documentUpload(event) {
    const files = event.target.files;
    if (files[0].size <= 15728640)//15mb
    {
      if (files[0].type.split('/')[1] == 'pdf') {
        this.multipartFileUpload(files[0])
      }
      else
        document.getElementById("docError").innerHTML = this.userService.translateText('patient_portal.upload_page.unsupported_file_format.error')
    }
    else {
      document.getElementById("docError").innerHTML = this.userService.translateText('patient_portal.upload_page.15MB_file_allowed.error')
    }

    event.target.value = ''
  }

  /* ----------------multipart file upload function------------- */
  multipartFileUpload(file) {
    document.getElementById("docName").innerHTML = this.userService.translateText('patient_portal.upload_page.pdf_upload.error')
    document.getElementById("docError").innerHTML = ""
    this.timeInSec = 0

    if (this.patientDocuments.length < 5) {
      this.showloader = true
      this.byteToMbConverter(file.size)

      const formData = new FormData();
      var jobject = { "patientSwfId": this.patientSWFId, "userAccountId": this.currentuserDetails.item.userAccountId }

      formData.append("file", file)
      formData.append("value", this.userService.encrypt(JSON.stringify(jobject)))

      this.userService.savePatientDocument(formData).subscribe(data => {
        this.showloader = false
        this.upploadedPercentage = 0
        if (data.status == true) {
          this.toastr.success(data.message)
          this.fetchAllPatientDocument()

          if (this.mask == false) {
            var accordianHeader = document.getElementById("accHeader") as HTMLInputElement
            accordianHeader.click()
          }
        }
        else {
          this.toastr.error(data.message)
        }
        document.getElementById("docName").innerHTML = ''
      },
        err => {
          this.upploadedPercentage = 0
          this.timeInSec = 0
          this.time = 0
          document.getElementById("docName").innerHTML = '';
          this.showloader = false; this.toastr.error(this.userService.translateText('patient_portal.display_messages.something_went_wrong'))
        }
      )
    }
    else {
      document.getElementById("docError").innerHTML = this.userService.translateText('patient_portal.upload_page.maximum_no_of_fle.error')
      document.getElementById("docName").innerHTML = ''
    }

  }
  /* ----------------get all Documentlist------------- */
  patientDocuments = []
  fetchAllPatientDocument() {
    var patientSwfId = { "patientSwfId": this.patientSWFId }
    this.userService.fetchAllPatientDocument(patientSwfId).subscribe(data => { this.patientDocuments = data })
  }
  /* ----------------print Document------------- */
  pdfUrl: any
  openModelprint(template: TemplateRef<any>, value) {
    let self = this;
    let data: any = {
      'patientSwfId': String(this.patientSWFId),
      'fileId': value.fileId,
      'preview': true,
      'loginUserId': String(this.currentuserDetails.item.userAccountId)
    }
    data = this.userService.encrypt(JSON.stringify(data))
    data = btoa(data)
    this.pdfUrl = this.downloadPatientDocuments + data + "&type=WEB"
    this.ModelRef = self.Modalservice.show(template, { class: 'modal-lg', backdrop: 'static' })
    document.getElementById("filename").innerHTML = value.filename
  }

  printpagenew(): void {
    window.open(this.pdfUrl, '_blank', 'top=0,left=0,height=100%,width=auto');
    this.ModelRef.hide()
  }

  /* ----------------Download Document------------- */
  downloadPatientDocuments: any = environment.downloadPatientDocuments
  downloadDoc(value) {
    let data: any = {
      'patientSwfId': String(this.patientSWFId),
      'fileId': value.fileId,
      'loginUserId': String(this.currentuserDetails.item.userAccountId),
      lang: this.userService.selectedLang()
    }
    data = this.userService.encrypt(JSON.stringify(data))
    data = btoa(data)
    window.open(this.downloadPatientDocuments + data + "&type=WEB");
  }

  /* ----------------delete Document------------- */
  dragHover = false
  deleteDocument(value) {
    var patientSwfId = { "patientSwfId": this.patientSWFId, "fileId": value.fileId, "fileName": value.filename, "userAccountId": this.currentuserDetails.item.userAccountId }
    this.userService.deletePatientDocument(patientSwfId).subscribe(data => {
      if (data.status == true) {
        this.toastr.success(data.message)
        document.getElementById("docError").innerHTML = ""
        this.fetchAllPatientDocument()
      }
      else {
        this.toastr.error(data.message)
      }
    })
  }

  time: number = 0
  byteToMbConverter(value) {
    if (value > 1024) {
      var kiloBytes = Math.round(value / 1024)
      var megaBytes = Math.round(kiloBytes / 1024)
      this.time = Math.round(megaBytes / 5)
      this.percentageCalculation()
    }
    else {
      this.upploadedPercentage = 100
    }

  }
  timeInSec = 0
  upploadedPercentage: number = 0;
  percentageCalculation() {

    if (this.time > 0) {
      if (this.timeInSec < (this.time - 1)) {
        if (this.showloader == true) {
          setTimeout(() => {
            this.timeInSec++;
            this.upploadedPercentage = this.timeInSec * (100 / this.time)
            this.upploadedPercentage.toFixed(2)
            document.getElementById("docName").innerHTML = this.upploadedPercentage.toFixed(2).toString() + "%"
            this.percentageCalculation();
          }, 1000)
        }
        else {
          document.getElementById("docName").innerHTML = ""
        }

      }
    }
    else {
      document.getElementById("docName").innerHTML = ""
    }

  }
}